import type { Claim } from '@boodschappenlijst/shared';
import { api } from '../../lib/apiClient';

export const claimApi = {
  huidig: () => api.get<{ claim: Claim | null }>('/claim'),
  /** Gooit een ApiError met status 409 als iemand anders sneller was. */
  claim: () => api.post<{ claim: Claim }>('/claim'),
  vrijgeven: () => api.del<{ ok: boolean; claim: Claim | null }>('/claim'),
};
